import { render, staticRenderFns } from "./ShippingMonthList.vue?vue&type=template&id=aea36282&scoped=true&"
import script from "./ShippingMonthList.vue?vue&type=script&lang=js&"
export * from "./ShippingMonthList.vue?vue&type=script&lang=js&"
import style0 from "./ShippingMonthList.vue?vue&type=style&index=0&id=aea36282&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea36282",
  null
  
)

export default component.exports